import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { EntityActivity } from 'components/EntityActivity';
import { React } from 'libs/react';
import './DealNotesStream.scss';
/**
 * @component DealNotesStream
 * @since 1.0.0
 */
export function DealNotesStream(props) {
    const { deal, setNotesStream } = props;
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    function onClose() {
        setNotesStream(false);
    }
    return (React.createElement("div", { className: "deal-notes-stream" },
        React.createElement("div", { className: "deal-notes-stream-head" },
            React.createElement("span", { className: "deal-notes-stream-picto", "aria-hidden": "true" },
                React.createElement(Icon, { value: "fal note-sticky" })),
            React.createElement("div", { className: "deal-notes-stream-title" },
                React.createElement("span", { className: "deal-notes-stream-title-value" }, t('Notes & reminders')),
                (deal === null || deal === void 0 ? void 0 : deal.number) && (React.createElement("span", { className: "deal-notes-stream-title-infos" }, (deal.type === 'AGREEMENT' ? t('Agreement') : t('Quote')) +
                    ' #' +
                    deal.number))),
            React.createElement(Button, { style: "picto", picto: "xmark", noPadding: true, onPress: onClose })),
        React.createElement("div", { className: "deal-notes-stream-container" },
            React.createElement(EntityActivity, { entity: "DEAL", entityId: deal === null || deal === void 0 ? void 0 : deal.id, variant: "sidebar" }))));
}
